import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';

Vue.use(Router);

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    }
    return { x: 0, y: 0 };
  },
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js